import React, { Component } from 'react'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { finishLoadPrintTemplate, loadPrintTemplate } from '../../actions'

class PrintOfficialPackageCustomizes extends Component {
    constructor(props) {
        super()

        props.loadPrintTemplate()
    }

    handleDidMount = () => {
        const { finishLoadPrintTemplate, onDidMount } = this.props

        finishLoadPrintTemplate()
        onDidMount()
    }

    componentDidMount() {
        const { logo } = this.props
        const packageData = this.props.package
        const isBatch = get(packageData, 'is_batch', false)

        if (isBatch || !logo) {
            this.handleDidMount()
        }
    }

    render() {
        return (
            <>
                <div className="print-package-official-stamp print-package-official-stamp-custom">Tem tuỳ chỉnh theo cấu hình</div>
            </>
        )
    }
}

PrintOfficialPackageCustomizes.defaultProps = {
    onDidMount: () => {},
}

PrintOfficialPackageCustomizes.propTypes = {
    onDidMount: PropTypes.func,
}

export default connect(undefined, {
    finishLoadPrintTemplate,
    loadPrintTemplate,
})(PrintOfficialPackageCustomizes)
